import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import logo from '../assets/logo.png';

const DriverRegistration: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="logo-section">
            <img src={logo} alt="Taxicim Logo" className="logo-img" />
          </div>
          <button 
            className="back-btn"
            onClick={() => navigate('/')}
          >
            ← Ana Sayfa
          </button>
          <h2>Şoför Kayıt</h2>
          <p>Taxicim Şoför Sistemi</p>
        </div>

        <div className="info-message">
          <div className="info-icon">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="#FFC107" strokeWidth="2"/>
              <path d="M12 16v-4M12 8h.01" stroke="#FFC107" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <h3>Önemli Bilgilendirme</h3>
          <p className="info-text">
            <strong>Şoför kayıtları sadece mobil uygulamadan yapılmaktadır.</strong>
          </p>
          <p className="info-description">
            Taxicim şoför sistemi hakkında detaylı bilgi almak ve kayıt olmak için 
            lütfen mobil uygulamamızı indirin ve kayıt sürecini mobil cihazınızdan tamamlayın.
          </p>
          
          <div className="download-info">
            <h4>Mobil Uygulamamızı İndirin</h4>
            <div className="download-buttons">
              <button 
                className="download-btn google-play"
                onClick={() => window.open('https://play.google.com/store/apps/details?id=com.microfinanceas.taxicim', '_blank')}
              >
                <div className="btn-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 20.5V3.5C3 2.4 3.89 1.5 5 1.5H19C20.1 1.5 21 2.4 21 3.5V20.5C21 21.6 20.1 22.5 19 22.5H5C3.89 22.5 3 21.6 3 20.5Z" stroke="currentColor" strokeWidth="2"/>
                  </svg>
                </div>
                <div className="btn-text">
                  <span>İndir</span>
                  <span>Google Play</span>
                </div>
              </button>
              <button 
                className="download-btn app-store"
                onClick={() => window.open('https://apps.apple.com/tr/app/taxicim/id6747424960', '_blank')}
              >
                <div className="btn-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18.71 19.5C17.88 20.74 17 21.95 15.66 21.97C14.32 22 13.89 21.18 12.37 21.18C10.84 21.18 10.37 21.95 9.09997 22C7.78997 22.05 6.79997 20.68 5.95997 19.47C4.24997 17 2.93997 12.45 4.69997 9.39C5.56997 7.87 7.12997 6.91 8.81997 6.88C10.1 6.86 11.32 7.75 12.11 7.75C12.89 7.75 14.37 6.68 15.92 6.84C16.57 6.87 18.39 7.1 19.56 8.82C19.47 8.88 17.39 10.1 17.41 12.63C17.44 15.65 20.06 16.66 20.09 16.67C20.06 16.74 19.67 18.11 18.71 19.5ZM13 3.5C13.73 2.67 14.94 2.04 15.94 2C16.07 3.17 15.6 4.35 14.9 5.19C14.21 6.04 13.07 6.7 11.95 6.61C11.8 5.46 12.36 4.26 13 3.5Z" fill="currentColor"/>
                  </svg>
                </div>
                <div className="btn-text">
                  <span>İndir</span>
                  <span>App Store</span>
                </div>
              </button>
            </div>
          </div>

          <div className="contact-info">
            <h4>Yardım İçin İletişim</h4>
            <p>Herhangi bir sorunuz için bizimle iletişime geçebilirsiniz:</p>
                          <p className="phone">📞 08502428876</p>
            <p className="email">📧 info@taxicim.com.tr</p>
          </div>
        </div>

        <div className="login-footer">
          <p>
            Zaten hesabınız var mı? 
            <a onClick={() => navigate('/login')}> Giriş Yap</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default DriverRegistration; 